import React, { Component } from "react";
import { DeviceContext } from "context/deviceProvider";
import "scss/screens/deviceData/machineProfile.scss";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import LetterLoading from "components/loading/letterLoading";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import MachineModal from "components/modals/deviceData/machineModal";
import RealtimeDevice from "screens/deviceData/realtimeDevice";

export default class MachineProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      searchName: null,
      deviceList: [],
      deviceDetail: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      detailModal: false,
    };
  }
  

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });
  setDetailModal = () =>
    this.setState({ detailModal: !this.state.detailModal });
    

  async componentDidMount() {
    this.startLoading();
    await this.setDeviceData({ name: null, level: -1 });
    this.stopLoading();
  }
  
  // setDeviceData = async (data) => {
  //   const { getAllLinkDevices } = this.context;
  //   await getAllLinkDevices(data);
  //   this.setState({
  //     deviceList: this.context.allDevicesList.slice(
  //       this.state.begin,
  //       this.state.end
  //     ),
  //   });
  // };

  setDeviceData = async () => {
    const clpMemberListAll = await this.context.getClpMemberAll();
    // console.log("MemberListAlls", clpMemberListAll);

    console.log("searchName", this.state.searchName );
    this.setState({
      deviceList: clpMemberListAll.filter(de => de.is_delete === 0)
    }, () => {
      console.log("deviceList", this.state.deviceList);
    });

    this.setState({
      deviceHitory: clpMemberListAll.filter(de => de.is_delete === 1)
    }, () => {
      console.log("deviceHitory", this.state.deviceHitory);
    });

    if (this.state.searchName != null) {
      this.setState((prevState) => ({
        deviceList: clpMemberListAll.filter(de => de.clp_serial === prevState.searchName)
      }), () => {
        console.log("deviceLists", this.state.deviceList);
      });
    }
  };

  //  setDeviceData = async (data) => {
  //   const { getAllLinkDevices } = this.context;
  //   await getAllLinkDevices(data);
  //   this.setState({
  //     deviceList: this.context.allDevicesList.slice(
  //       this.state.begin,
  //       this.state.end
  //     ),
  //   });
  // };

  createDeviceSearch = () => {
    // const { allDevicesList } = this.context;
    const { searchName } = this.state;
    const deviceOptions = this.state.deviceList?.map((user) => ({
      key: user.device_serial,
      value: user.clp_serial,
      text: user.clp_serial,
    }));
    return (
      <div className="search">
        <Form>
          <b>หมายเลขเครื่องจักร</b>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={deviceOptions}
              value={searchName}
              placeholder="หมายเลขเครื่องจักร"
              search
              onChange={(e, { value }) => this.setState({ searchName: value })}
            />
            <Button
              onClick={() => {
                this.setDeviceData({ name: null, level: -1 });
                this.setState({
                  searchName: null,
                  level: -1,
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            &ensp;
            <Button
              color="blue"
              onClick={() => {
                this.setDeviceData({ name: this.state.searchName});
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              ค้นหา
            </Button>
          </Form.Group>
        </Form>
      </div>
    );
  };
 
  createDeviceTable = () => {
    const { deviceList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>หมายเลขเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>หมายเลขอุปกรณ์ IoT</Table.HeaderCell>
            <Table.HeaderCell>แสดงข้อมูลเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>แสดงข้อมูลการทำงาน</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {deviceList != null &&
            deviceList?.map((device, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>{device.clp_serial}</Table.Cell>
                <Table.Cell>{device.device_serial}</Table.Cell>
                <Table.Cell>
                  <Button
                    color="twitter"
                    onClick={() => {
                      this.setDetailModal();
                      this.setState({ deviceDetail: device });

                      this.setState({
                        deviceHitoryList: this.state.deviceHitory
                          .filter(de => de.clp_serial === device.clp_serial)
                          .sort((a, b) => new Date(b.devicebuy_date) - new Date(a.devicebuy_date))
                      }, () => {
                        console.log("deviceHitoryList", this.state.deviceHitoryList);
                      });                     
                    }}
                  >
                    <Icon name="file alternate outline" />
                    รายละเอียด
                  </Button>
                </Table.Cell>
                      
                <Table.Cell>
                  <Button
                    color="twitter"
                    href={`/realtime-device/${device.device_serial}`}
                    onClick={() => (<RealtimeDevice data = {device.device_serial}/>)}>
                    <Icon name="list alternate outline" />
                    รายละเอียด
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    );
  };

  createActiveTime = (data) => {
    const newData = data.split(":");
    return (
      <>
        {newData[0] !== "0" ? `${newData[0]} ชั่วโมง` : null}{" "}
        {newData[1] !== "0" ? `${newData[1]} นาที` : null} {newData[2]} วินาที
      </>
    );
  };

  paginationUpdate = (e, data) => {
    // const { this.state.deviceList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      deviceList: [...this.state.deviceList.slice(beginIdx, endIdx)],
    });
  };

  render() {const { isLoading, activePage, pageSize, detailModal, deviceDetail } = this.state;
    return (
      <div className="machineProfile">
        <LetterLoading isOpen={isLoading} />
        <Navigation />
        <Sidebar tabActive="deviceData" reports="machineList" />
        
        <MachineModal
          isOpen={detailModal}
          data={deviceDetail}
          dataHitory={this.state.deviceHitoryList}
          isClose={this.setDetailModal}
        />
   
        <div className="machineProfile-content">
          <h2>Machine Profile</h2>
          <hr />

          <div className="machineProfile-content-search">
            {this.createDeviceSearch()}     
                 
          </div>
          
          <div className="machineProfile-content-table">
            {this.createDeviceTable()}
          </div>
          <div className="machineProfile-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.state.deviceList?.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}
MachineProfile.contextType = DeviceContext;
